// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.composer-preview-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.composer-preview-modal {
    width: min(680px, 100%);
    max-height: 90vh;
    overflow: auto;
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    box-shadow: 0 18px 48px rgba(0, 0, 0, 0.35);
    position: absolute;
    top: 0;
}

.composer-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-color);
}

.composer-preview-header h3 {
  margin: 0;
  font-size: 1rem;
  color: var(--text-primary);
}

.composer-preview-close {
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-size: 1.1rem;
  cursor: pointer;
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.composer-preview-close:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.composer-preview-card {
  margin: 14px;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
}

.composer-preview-live-card {
  margin: 0;
}

.composer-preview-live-card-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.composer-preview-live-card-meta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary);
  font-size: 0.78rem;
}

.composer-preview-live-card-meta .post-via-app {
  color: var(--text-secondary);
  font-size: 0.78rem;
  white-space: nowrap;
}

.composer-preview-live-card-meta .post-via-app em {
  font-style: italic;
}

.composer-preview-live-card .post-card,
.composer-preview-live-card .comment-card {
  margin: 0;
}

.composer-preview-author-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.composer-preview-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.composer-preview-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.composer-preview-meta-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.composer-preview-meta strong {
  color: var(--text-primary);
  font-size: 0.95rem;
}

.composer-preview-meta span {
  color: var(--text-secondary);
  font-size: 0.78rem;
}

.composer-preview-meta .post-via-app {
  color: var(--text-secondary);
  font-size: 0.78rem;
  white-space: nowrap;
}

.composer-preview-meta .post-via-app em {
  font-style: italic;
}

.composer-preview-body {
  color: var(--text-primary);
}

.composer-preview-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 14px 14px;
  border-top: 1px solid var(--border-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/ComposerPreviewModal/ComposerPreviewModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,+BAA+B;IAC/B,qCAAqC;IACrC,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,MAAM;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,uBAAuB;EACvB,yCAAyC;AAC3C","sourcesContent":[".composer-preview-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1200;\r\n  background: rgba(0, 0, 0, 0.6);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px;\r\n}\r\n\r\n.composer-preview-modal {\r\n    width: min(680px, 100%);\r\n    max-height: 90vh;\r\n    overflow: auto;\r\n    background: var(--bg-secondary);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 12px;\r\n    box-shadow: 0 18px 48px rgba(0, 0, 0, 0.35);\r\n    position: absolute;\r\n    top: 0;\r\n}\r\n\r\n.composer-preview-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 14px 16px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.composer-preview-header h3 {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.composer-preview-close {\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  font-size: 1.1rem;\r\n  cursor: pointer;\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.composer-preview-close:hover {\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.composer-preview-card {\r\n  margin: 14px;\r\n  padding: 14px;\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border-color);\r\n  background: var(--bg-primary);\r\n}\r\n\r\n.composer-preview-live-card {\r\n  margin: 0;\r\n}\r\n\r\n.composer-preview-live-card-wrap {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.composer-preview-live-card-meta {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: var(--text-secondary);\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.composer-preview-live-card-meta .post-via-app {\r\n  color: var(--text-secondary);\r\n  font-size: 0.78rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.composer-preview-live-card-meta .post-via-app em {\r\n  font-style: italic;\r\n}\r\n\r\n.composer-preview-live-card .post-card,\r\n.composer-preview-live-card .comment-card {\r\n  margin: 0;\r\n}\r\n\r\n.composer-preview-author-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.composer-preview-avatar {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.composer-preview-meta {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.composer-preview-meta-row {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.composer-preview-meta strong {\r\n  color: var(--text-primary);\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.composer-preview-meta span {\r\n  color: var(--text-secondary);\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.composer-preview-meta .post-via-app {\r\n  color: var(--text-secondary);\r\n  font-size: 0.78rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.composer-preview-meta .post-via-app em {\r\n  font-style: italic;\r\n}\r\n\r\n.composer-preview-body {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.composer-preview-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n  padding: 12px 14px 14px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
